export default {
      id: "ms-powerpoint-document-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#ms-powerpoint-document",
      toString: function () {
        return this.url;
      }
    }